if(!customElements.get('blog-navigation')) {
  class BlogNavigation extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.elLinks = this.querySelectorAll('a');
      this.elLinks.forEach(el => {
        el.addEventListener('click', this.loadNewBlog.bind(this));
      })
    }

    loadNewBlog(ev) {
      ev.preventDefault();
      const { currentTarget: elLink } = ev;
      const { href } = elLink;
      const elArticles = document.querySelectorAll('.blog-articles');

      this.elLinks.forEach(el => el.parentNode.classList.toggle('active', el == elLink));
      elArticles.forEach(el => el.classList.add('loading'));

      this.fetchBlog(href)
        .then(elGrids => {
          elArticles.forEach(el => el.remove());
          elGrids.forEach(el => el.classList.add('loading'));
          return elGrids;
        })
        .then(elGrids => {
          elGrids.forEach(el => document.querySelector('main').appendChild(el));
          window.initLazyLoad();
          return elGrids;
        })
        .then(elGrids => {
          setTimeout(() => elGrids.forEach(el => el.classList.remove('loading')))
        })
        .catch(err => {
          console.log(err);
          elArticles.forEach(el => el.classList.remove('loading'));
        })
    }

    async fetchBlog(url) {
      const response = await fetch(url);
      const data = await response.text();

      const html = new DOMParser().parseFromString(data, 'text/html');
      const elGrids = html.querySelectorAll('.blog-articles');

      return elGrids;
    }
  }

  customElements.define('blog-navigation', BlogNavigation);
}